import React, { createContext, useState, useContext } from "react";

const UnsavedChangesContext = createContext();

export const UnsavedChangesProvider = ({ children }) => {
  console.log("UnsavedChangesProvider rendered");
  const [isDirty, setIsDirty] = useState(false);
  const [showNavigationModal, setShowNavigationModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  const confirmNavigation = () => {
    if (pendingNavigation) {
      pendingNavigation(); // Execute the stored navigation action
    }
    setShowNavigationModal(false);
    setIsDirty(false); // Reset dirty state
  };

  const cancelNavigation = () => {
    setShowNavigationModal(false);
    setPendingNavigation(null);
  };

  return (
    <UnsavedChangesContext.Provider
      value={{
        isDirty,
        setIsDirty,
        showNavigationModal,
        setShowNavigationModal,
        pendingNavigation,
        setPendingNavigation,
        confirmNavigation,
        cancelNavigation,
      }}
    >
      {children}
    </UnsavedChangesContext.Provider>
  );
};

export const useUnsavedChanges = () => useContext(UnsavedChangesContext);